import useConfigStore from "../stores/useConfigStore";

// POS-06: priority can arrive as a string ("10") depending on the sync source. Compared as strings,
// "10" < "9", so a priority-10 rule lost to a priority-9 rule on the line-level guards. Normalise it to
// a Number (or null when missing/unreadable) once per pricingRules array, not on every lookup.
const toPriority = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

let lastSource = null;
let lastNormalised = [];

export const normalisePricingRules = (rules) =>
  (rules || []).map((rule) => {
    if (!rule || typeof rule !== "object") return rule;
    const priority = toPriority(rule.priority);
    return priority === rule.priority ? rule : { ...rule, priority };
  });

export const getPricingRules = () => {
  const source = useConfigStore.getState().pricingRules || [];
  if (source !== lastSource) {
    lastSource = source;
    lastNormalised = normalisePricingRules(source);
  }
  return lastNormalised;
};

export const findPricingRuleById = (id) => {
  if (!id) return [];
  const lower = id.toLowerCase();
  return getPricingRules().filter(
    (r) => (r.mPricingrulesId || "").toLowerCase() === lower
  );
};
